import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('es');

@Pipe({
  name: 'iwDateCalendar'
})
export class DateCalendarPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const [add, subtract] = args;
    if (add) {
      return value
        ? moment(value)
            .add(add)
            .calendar()
        : value;
    }
    if (subtract) {
      return value
        ? moment(value)
            .subtract(add)
            .calendar()
        : value;
    }
    return value ? moment(value).calendar() : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/moment/date-calendar.pipe.ts